import React from 'react';
import { Input } from 'antd';
import usePlacesAutocomplete, { getGeocode, getLatLng } from 'use-places-autocomplete';

const LocationAutocompleteWrapper = ({ onChange, onClear }) => {
	const {
		ready,
		value,
		setValue,
		suggestions: { status, data },
		clearSuggestions,
	} = usePlacesAutocomplete({
		requestOptions: {},
		debounce: 300,
	});

	const handleSelect = async (address) => {
		setValue(address, false);
		clearSuggestions();

		try {
			const results = await getGeocode({ address });
			const latLng = await getLatLng(results[0]);
			onChange(latLng); // Pass only lat/lng to form
		} catch (error) {
			console.error('Error during geocoding:', error);
		}
	};

	const handleChange = (text) => {
		setValue(text);
		if (text === '') {
			onClear();
		}
	};

	return (
		<div style={{ position: 'relative' }}>
			<Input
				size="large"
				value={value}
				onChange={(e) => handleChange(e.target.value)}
				placeholder="Search Places ..."
				allowClear
				disabled={!ready}
			/>
			{status === 'OK' && data.length > 0 && (
				<div
					className="autocomplete-dropdown-container"
					style={{
						position: 'absolute',
						zIndex: 1000,
						background: '#fff',
						border: '1px solid #ccc',
						width: '100%',
						maxHeight: 200,
						overflowY: 'auto',
					}}
				>
					{data.map((suggestion) => {
						const style = {
							backgroundColor: '#fff',
							cursor: 'pointer',
							padding: 8,
						};
						return (
							<div
								key={suggestion.place_id}
								onClick={() => handleSelect(suggestion.description)}
								className="suggestion-item"
								style={style}
							>
								<span>{suggestion.description}</span>
							</div>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default LocationAutocompleteWrapper;
